import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import '../styles/TermsOfService.css';

function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      className="terms-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <Link to="/">
              <img src="/images/logo.png" alt="Fotomista" />
            </Link>
          </div>
          <ul className="nav-menu">
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/contact">اتصل بنا</Link></li>
          </ul>
        </div>
      </nav>

      <section className="terms-hero">
        <div className="terms-container">
          <motion.h1
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            الشروط والأحكام
          </motion.h1>

          <motion.p
            className="terms-subtitle"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام خدماتنا
          </motion.p>

          <motion.div
            className="terms-last-updated"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.35 }}
          >
            آخر تحديث: ٤ مارس ٢٠٢٦
          </motion.div>

          <motion.div
            className="terms-content"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >

            <div className="terms-section">
              <h2>١. مقدمة</h2>
              <p>
                مرحباً بكم في فوتوميستا (Fotomista)، خدمة تأجير كبائن التصوير الاحترافية للمناسبات والفعاليات في المملكة العربية السعودية.
                يُدير هذه الخدمة <strong>حسن محمد بن صالح القطان</strong>، بموجب وثيقة العمل الحر رقم <strong>FL-547130542</strong> ورقم التوثيق <strong>0000191613</strong>.
              </p>
              <p>
                باستخدامك لموقعنا الإلكتروني أو حجز أي من خدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه الشروط، يرجى عدم استخدام خدماتنا.
              </p>
            </div>

            <div className="terms-section">
              <h2>٢. وصف الخدمة</h2>
              <p>توفر فوتوميستا خدمة تأجير كبائن التصوير (Photo Booth) للمناسبات الخاصة والفعاليات في أنحاء المملكة العربية السعودية، وتشمل خدماتنا:</p>
              <ul>
                <li>تأجير كبائن التصوير بأنواعها (كلاسيكية وعصرية)</li>
                <li>تقديم خدمة التصوير الاحترافي خلال المناسبات</li>
                <li>توفير نظام حجز مرن (بالساعات أو بنظام التذاكر)</li>
                <li>طباعة الصور الفورية وتقديمها بأحدث التقنيات</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>٣. شروط الحجز</h2>
              <ul>
                <li>يجب تقديم بيانات صحيحة ودقيقة عند إجراء الحجز (الاسم الكامل، رقم الجوال، البريد الإلكتروني، تاريخ ومكان المناسبة).</li>
                <li>يُعتبر الحجز مؤكداً بعد إتمام عملية الدفع بنجاح.</li>
                <li>يحق لفوتوميستا رفض أي حجز لأي سبب تراه مناسباً.</li>
                <li>يجب أن يكون مقدم الحجز قد بلغ ١٨ عاماً على الأقل أو أن يتم الحجز بمعرفة ولي الأمر.</li>
                <li>يلتزم العميل بتوفير مساحة مناسبة وآمنة لتركيب الكابينة في موقع المناسبة.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>٤. الأسعار والدفع</h2>
              <ul>
                <li>جميع الأسعار المعروضة هي بالريال السعودي وشاملة لضريبة القيمة المضافة إن وُجدت.</li>
                <li>يتم الدفع إلكترونياً عبر بوابات الدفع المعتمدة (Geidea أو Tamara).</li>
                <li>في حالة اختيار الدفع عبر تمارا (Tamara)، تُطبق شروط وأحكام تمارا الخاصة بالتقسيط.</li>
                <li>تحتفظ فوتوميستا بحق تعديل الأسعار في أي وقت، على أن التعديل لا يسري على الحجوزات المؤكدة مسبقاً.</li>
              </ul>
            </div>

            <div className="terms-section highlight-section">
              <h2>٥. سياسة الإلغاء والاسترداد</h2>
              <div className="policy-card">
                <div className="policy-icon">§</div>
                <div className="policy-content">
                  <h3>الإلغاء في أي وقت</h3>
                  <p>يحق للعميل إلغاء الحجز في أي مرحلة من مراحل الخدمة.</p>
                </div>
              </div>
              <div className="policy-card warning">
                <div className="policy-icon">!</div>
                <div className="policy-content">
                  <h3>عدم استرداد العربون</h3>
                  <p>
                    في حال إلغاء الحجز <strong>قبل أقل من شهر (٣٠ يوماً)</strong> من تاريخ المناسبة، لا يُسترد مبلغ العربون المدفوع.
                    أما في حال الإلغاء قبل شهر أو أكثر من تاريخ المناسبة، يتم استرداد كامل المبلغ.
                  </p>
                </div>
              </div>
              <div className="policy-card">
                <div className="policy-icon">↩</div>
                <div className="policy-content">
                  <h3>طريقة الاسترداد</h3>
                  <p>يتم الاسترداد بنفس طريقة الدفع الأصلية خلال مدة لا تتجاوز ١٤ يوم عمل من تاريخ الموافقة على طلب الإلغاء.</p>
                </div>
              </div>
            </div>

            <div className="terms-section">
              <h2>٦. التزامات العميل</h2>
              <ul>
                <li>الحفاظ على معدات وأجهزة الكابينة وعدم العبث بها أو إتلافها.</li>
                <li>يتحمل العميل تكاليف إصلاح أو استبدال أي أضرار تلحق بالمعدات نتيجة سوء الاستخدام.</li>
                <li>توفير مصدر طاقة كهربائية مناسب في موقع المناسبة.</li>
                <li>إبلاغ فوتوميستا بأي تغيير في تفاصيل المناسبة قبل وقت كافٍ.</li>
                <li>عدم استخدام الكابينة لأي غرض مخالف للأنظمة المعمول بها في المملكة العربية السعودية.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>٧. حقوق الملكية الفكرية</h2>
              <p>
                جميع المحتويات المعروضة على الموقع، بما في ذلك التصاميم والشعارات والنصوص والصور والرسومات، هي ملكية حصرية لفوتوميستا ومحمية بموجب أنظمة حقوق الملكية الفكرية في المملكة العربية السعودية.
              </p>
              <p>
                يُحظر نسخ أو إعادة إنتاج أو توزيع أي محتوى من الموقع دون الحصول على إذن كتابي مسبق من فوتوميستا.
              </p>
            </div>

            <div className="terms-section">
              <h2>٨. الصور الملتقطة خلال المناسبة</h2>
              <p>
                تقدم فوتوميستا خدمة طباعة الصور الفورية فقط خلال المناسبة. لا يتم تقديم نسخ رقمية (إلكترونية) من الصور للعملاء أو الحضور.
              </p>
              <p>
                يتم حذف جميع الصور والملفات الرقمية المؤقتة من أنظمتنا بعد انتهاء المناسبة مباشرةً، ولا تحتفظ فوتوميستا بأي نسخ منها.
              </p>
            </div>

            <div className="terms-section">
              <h2>٩. حدود المسؤولية</h2>
              <ul>
                <li>لا تتحمل فوتوميستا المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية ناتجة عن استخدام خدماتنا.</li>
                <li>لا تتحمل فوتوميستا المسؤولية عن أي تأخير أو عدم أداء ناتج عن ظروف قاهرة خارجة عن إرادتنا.</li>
                <li>في جميع الأحوال، لا تتجاوز مسؤولية فوتوميستا المبلغ المدفوع فعلياً مقابل الخدمة المعنية.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>١٠. القوة القاهرة</h2>
              <p>
                لا تتحمل فوتوميستا أي مسؤولية عن التأخير أو الإخلال بالتزاماتها نتيجة لأحداث خارجة عن السيطرة المعقولة، بما في ذلك على سبيل المثال لا الحصر: الكوارث الطبيعية، الأوبئة، الأعمال الحكومية، أو أي ظرف قاهر آخر.
              </p>
            </div>

            <div className="terms-section">
              <h2>١١. التعديل على الشروط</h2>
              <p>
                تحتفظ فوتوميستا بالحق في تعديل هذه الشروط والأحكام في أي وقت. سيتم نشر أي تعديلات على هذه الصفحة، ويُعتبر استمرارك في استخدام خدماتنا بعد النشر بمثابة موافقة منك على الشروط المُعدّلة.
              </p>
            </div>

            <div className="terms-section">
              <h2>١٢. القانون الحاكم</h2>
              <p>
                تخضع هذه الشروط والأحكام لأنظمة وقوانين المملكة العربية السعودية وتُفسّر وفقاً لها. في حال نشوء أي نزاع يتعلق بهذه الشروط، يتم حله ودياً أولاً، وفي حال تعذر ذلك، يختص القضاء السعودي بالفصل فيه.
              </p>
            </div>

            <div className="terms-section">
              <h2>١٣. التواصل</h2>
              <p>لأي استفسارات أو ملاحظات حول هذه الشروط والأحكام، يمكنكم التواصل معنا عبر:</p>
              <div className="contact-info-box">
                <div className="contact-info-item">
                  <span className="contact-label">البريد الإلكتروني:</span>
                  <a href="mailto:fotomista.sa@gmail.com">fotomista.sa@gmail.com</a>
                </div>
                <div className="contact-info-item">
                  <span className="contact-label">واتساب:</span>
                  <a href="https://wa.me/966503859150" target="_blank" rel="noopener noreferrer">+966503859150</a>
                </div>
              </div>
            </div>

          </motion.div>
        </div >
      </section >

      <Footer />
    </motion.div >
  );
}

export default TermsOfService;
